export const yukiLines = {
  teahouse: {
    lines: [
      { speaker: "Yuki", text: "Cherry buds still sleep,\nToo soon to ask where roots go—\nPatience warms the bloom." },
      { speaker: "Randy", text: "Roots? Like... tree Wi-Fi?\nI wait, but nothing connects.\nDo I water it?" },

      { speaker: "Yuki", text: "Rain does not explain\nWhy it falls on certain leaves—\nJust be still and wait." },
      { speaker: "Randy", text: "Rain hits me each time—\nmy shirt’s soaked but still no clue.\nCan we get indoors?" },

      { speaker: "Yuki", text: "A kettle will sing,\nOnly when it’s held with care—\nYour hands seem steady." },
      { speaker: "Randy", text: "Steady like my tan,\nfrom sipping beer in Cancun—\nI hold mugs real good." },

      { speaker: "Yuki", text: "Lanterns in the fog,\nNot lost, only glowing slow—\nThat’s how hearts return." },
      { speaker: "Randy", text: "My heart’s GPS\nkeeps rerouting toward you.\nCan I stay the night?" }
    ],
    voices: [
      "yuki_tea1",
      "yuki_tea2",
      "yuki_tea3",
      "yuki_tea4"
    ],
    randyVoices: [
      "randy_tea1",
      "randy_tea2",
      "randy_tea3",
      "randy_tea4"
    ]
  },

  cstore: {
    lines: [
      { speaker: "Yuki", text: "The shelves, like trees, stand tall,\nStocked with goods that grow daily—\nI tend them as I would a garden." },
      { speaker: "Randy", text: "Your store’s like Whole Foods,\nif Whole Foods had mochi balls.\nAlso, you’re cute. Hi." },

      { speaker: "Yuki", text: "The hum of the fridge is like the wind,\nCarrying whispers of faraway places—\nI often wonder who they’re meant for." },
      { speaker: "Randy", text: "Heard that fridge just hum—\nmight be flirting back with me.\nShould I hum back too?" },

      { speaker: "Yuki", text: "Customers pass like leaves on a stream,\nSometimes still, sometimes swift—\nBut they always leave, as all do." },
      { speaker: "Randy", text: "But I’m not a leaf,\nI’m like... a damp Hawaiian shirt—\nClings until removed." },

      { speaker: "Yuki", text: "The cashier's counter is like a rock,\nQuiet, but steady through the ebb and flow—\nI feel the pulse of the store in my hands." },
      { speaker: "Randy", text: "Your hands pulse with grace.\nMy hands hold discount sushi.\nWe both hold something." },

      { speaker: "Yuki", text: "My sister’s call is like a bird’s song,\nSoft, yet clear over the noise—\nI wait for that, more than anything." },
      { speaker: "Randy", text: "My ringtone is loud.\nShe says my voice is louder.\nStill, I’d wait for you." }
    ],
    voices: [
      "yuki_cstore1",
      "yuki_cstore2",
      "yuki_cstore3",
      "yuki_cstore4",
      "yuki_cstore5"
    ],
    randyVoices: [
      "randy_cstore1",
      "randy_cstore2",
      "randy_cstore3",
      "randy_cstore4",
      "randy_cstore5"
    ]
  }
};

export default yukiLines;
